import { useContext, useEffect } from 'react';
import { trackEvent } from 'shared/analytics';
import { GlobalContext } from 'shared/context';
import { EventPropertyKey, Events } from 'shared/enums/events';

export const AnalyticsSessionTracker = () => {
  const { loggedUser } = useContext(GlobalContext);

  useEffect(() => {
    if (!loggedUser?.id || !loggedUser.orgName) {
      return;
    }

    trackEvent(Events.AnalyticsUserReady, {
      [EventPropertyKey.UserId]: loggedUser.id,
      [EventPropertyKey.OrganizationName]: loggedUser.orgName,
    });

    trackEvent(Events.SessionStarted);
  }, [loggedUser?.id, loggedUser?.orgName]);

  return null;
};
